import { extract, logger, processValues, svcApi } from '.';
import { Report } from '@crops';
import ApiMapper from '../constant/ApiMapper';

type OverviewParam = {
  url: string;
  param: {
    CurrencyID: 'KRW' | 'USD';
    PartyID: string;
    StdDate: Date;
    kap_ServiceID: string;
  };
};

type TCountParam = {
  url: string;
  param: {
    prjId: string;
    gubunSearch: string;
    regCltvCd?: string;
    userSggCd?: string;
    userEmdCd?: string;
    userLiCd?: string;
    regSggCd?: string;
    regEmdCd?: string;
    regLiCd?: string;
    dclrTypeCd?: string;
    regUserNm?: string;
    userNm?: string;
  };
};

type TListParam = {
  url: string;
  param: {
    prjId: string;
    gubunSearch: string;
    pageNo: number;
    pageSize: number;
    regCltvCd?: string;
    userSggCd?: string;
    userEmdCd?: string;
    userLiCd?: string;
    regSggCd?: string;
    regEmdCd?: string;
    regLiCd?: string;
    dclrTypeCd?: string;
    regUserNm?: string;
    userNm?: string;
  };
};

type TUserInfo = {
  url: string;
  param: {
    userIdnt: string;
  };
};

type TUserInfoDetail = {
  url: string;
  param: {
    userIdnt: string;
    prjId: string;
    dclrTypeCd?: string;
  };
};

type TDetail = {
  url: string;
  param: {
    userIdnt: string;
    prjId: string;
    pageNo?: number;
    pageSize?: number;
  };
};

type TDeleteForm = {
  url: string;
  param: {
    regUserId: string;
    regSeq: string;
  };
};

type TCadastral = {
  regSggCd: string;
  regEmdCd: string;
  regLiCd: string;
  regJibun: string;
};

const ReportApi = {
  Overview: async (reqParam: OverviewParam) => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  Years: async (reqParam: string): Promise<Array<Report.TYears>> => {
    const result = await svcApi.get(reqParam);

    return extract(result);
  },
  Total: async (reqParam: TCountParam): Promise<number> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  List: async (reqParam: TListParam) => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  UserInfo: async (reqParam: TUserInfo): Promise<Report.TUserDetail> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  DetailListTotal: async (reqParam: TUserInfoDetail): Promise<number> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  DetailList: async (reqParam: TDetail): Promise<Array<Report.TDetailList>> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  DeleteDetails: async (reqParam: TDeleteForm): Promise<Array<Report.TDetailList>> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  Cadastral: async (reqParam: TCadastral) => {
    const result = await svcApi.get(ApiMapper.REPORT.ADD.CADASTRAL, {
      params: processValues(reqParam),
    });

    return extract(result);
  },
  DeleteReportDetail: async ({ regUserId, regSeq }): Promise<any> => {
    const result = await svcApi.delete(ApiMapper.REPORT.DETAIL.DELETE_DATA, {
      params: {
        regUserId: regUserId,
        regSeq: regSeq,
      },
    });

    logger(result);

    return result;
  },
  updateDetailReport: async (param: Report.TUpdateDetail): Promise<any> => {
    const result = await svcApi.put(ApiMapper.REPORT.DETAIL.UPDATE, param);

    logger(result);

    return result;
  },
  addRegisterOnlyOne: async (body: Report.TAddRequest): Promise<any> => {
    const result = await svcApi.post(ApiMapper.REPORT.DETAIL.ADD_DATA, body);

    logger(result);

    return extract(result);
  },
  deleteAllRegs: ({ userIdnt, prjId }: { userIdnt: string; prjId: string }) => {
    return svcApi.delete(ApiMapper.REPORT.DETAIL.DELETE_ALL_DATA, {
      params: {
        userIdnt,
        prjId,
      },
    });
  },
  lastData: async ({ prjId, userIdnt, regPnu }: { prjId: string; userIdnt: string; regPnu: string }) => {
    const result = await svcApi.get(ApiMapper.REPORT.LIST.LAST_DATA, {
      params: { prjId: prjId, userIdnt: userIdnt, regPnu: regPnu },
    });

    logger(result);

    return extract(result);
  },

  // printDeclare: ()
};

export default ReportApi;
